import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from "rxjs";
import { COMPLAINT_DIALOG_TEXT } from './complaint-dialog-text';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DEFAULT_ALLOWED_EXTENSIONS, DEFAULT_MAX_UPLOAD_FILE_SIZE_ADMIN, DEFAULT_MAX_UPLOAD_FILE_SIZE_USER } from 'libs/ux-components/src/lib/container/treatment-media/treatment-media.component';
import { MatButtonModule } from '@angular/material/button';
import { FileUploadBoxComponent } from "libs/media/src/lib/components/file-upload/file-upload-box/file-upload-box.component";
import { select, Store } from '@ngrx/store';
import { MediaState } from "libs/media/src/lib/store/media.reducer";
import { selectIdFromUrl } from 'libs/tm-common/src/lib/store/selectors';

@Component({
	selector: 'ux-complaint-dialog',
	standalone: true,
	templateUrl: './complaint-dialog.component.html',
	styleUrls: ['./complaint-dialog.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		TranslateModule,
		MatButtonModule,
		FileUploadBoxComponent
	]
})
export class ComplaintDialogComponent implements OnDestroy{

	allowedExtensions = DEFAULT_ALLOWED_EXTENSIONS;
	allowedMaxFileSize = DEFAULT_MAX_UPLOAD_FILE_SIZE_USER;
	isInputEnabled: boolean = true;
	isFileListDisplayEnabled: boolean = true;

	private translateSubscription: Subscription;
	private treatmentIdSubscription: Subscription;
	protected submitComplaintText: string;
	protected params: { treatment: string } = null;
	userInput = new FormControl;

	constructor(
		private translate: TranslateService,
		private store: Store<MediaState>,
		public dialogRef: MatDialogRef<ComplaintDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.userInput = new FormControl(data.userText || '', Validators.required);
		this.submitComplaintText =
			COMPLAINT_DIALOG_TEXT[this.translate.currentLang] ||
			COMPLAINT_DIALOG_TEXT.en;
		this.translateSubscription = this.translate.onLangChange.subscribe(
			(e) =>
				(this.submitComplaintText =
					COMPLAINT_DIALOG_TEXT[e.lang] || COMPLAINT_DIALOG_TEXT.en)
		);
	}

	ngOnInit(): void {
		this.treatmentIdSubscription = this.store.pipe(
			select(selectIdFromUrl))
			.subscribe(id => {
					this.params = { treatment: id };
		});
	}

	ngAfterViewInit() {  
		this.userInput.markAsTouched();
	}

	onSubmit(): void {
		if (this.userInput.valid) {
			this.dialogRef.close(this.userInput.value);
		}
	}

	onCancel(): void {
		this.dialogRef.close(null);
	}

	ngOnDestroy(): void {
		this.translateSubscription.unsubscribe();
		this.treatmentIdSubscription.unsubscribe();
	}
}
